module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rp-settings"
  }, [_c('div', {
    staticClass: "rp-settings-inner"
  }, [_c('div', {
    staticClass: "rp-rcontrols"
  }, [_c('a', {
    staticClass: "icon-save",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.saveProject
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "icon-cog",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.editProject
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "icon-times",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.closeProject
    }
  })]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), (_vm.description) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.compiledDescription)
    }
  }) : _vm._e(), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "rp-settings-add-layer",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.addLayer()
      }
    }
  }, [_vm._v("Add Layer")])])]), _vm._v(" "), _c('Draggable', {
    ref: "list",
    staticClass: "rp-layers",
    attrs: {
      "options": {
        handle: '.rp-layer-header-title'
      }
    },
    on: {
      "end": function($event) {
        _vm.$store.dispatch('project/moveLayer', $event)
      }
    }
  }, _vm._l((_vm.layers), function(l) {
    return _c('Layer', {
      key: l.id,
      attrs: {
        "layer": l,
        "selected": l.id == _vm.selectedLayerId
      }
    })
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-88fbc6d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/Main.vue
// module id = 482
// module chunks = 0